import { Panel } from "@maxhub/max-ui"
import { Typography } from "@maxhub/max-ui"

export const PanelExample = {
  title: "Panel",
  defaultPlatform: "ios",
  defaultZoom: 100,

  controls: [
    {
      name: "mode",
      label: "mode",
      type: "enum",
      tsType: ['"primary"', '"secondary"'],
      default: "primary",
      options: ["primary", "secondary"],
    },
    {
      name: "centeredX",
      label: "centeredX",
      type: "boolean",
      tsType: "boolean",
      default: false,
    },
    {
      name: "centeredY",
      label: "centeredY",
      type: "boolean",
      tsType: "boolean",
      default: false,
    },
  ],

  Preview({ props }) {
    return (
      <Panel
        mode={props.mode}
        centeredX={props.centeredX}
        centeredY={props.centeredY}
        style={{ width: "100%", height: 200 }}
      >
        <Typography.Body variant="medium">
          Panel body
        </Typography.Body>
      </Panel>
    )
  },

  getCode(props) {
    const lines = []
    if (props.mode !== "primary") lines.push(`  mode="${props.mode}"`)
    if (props.centeredX) lines.push(`  centeredX`)
    if (props.centeredY) lines.push(`  centeredY`)

    const propsStr = lines.length > 0 ? "\n" + lines.join("\n") + "\n" : ""
    return `<Panel${propsStr}>
  <Typography.Body variant="medium">
    Panel body
  </Typography.Body>
</Panel>`
  },
}